import Link from "next/link";

const DesktopOnlyNotice = () => {
  return (
    <>
      <div className="pointer-events-none fixed inset-0 bg-white bg-opacity-90 p-4"></div>
      <div
        className="fixed inset-0 flex flex-col items-center justify-center bg-white p-4"
        style={{ zIndex: 99999 }}
      >
        <h2 className="mb-4 text-2xl font-bold text-black">
          Desktop Only Feature
        </h2>
        <p className="mb-6 text-center text-black">
          This feature is not available on mobile. Please switch to a desktop
          device for the best experience.
        </p>
        <div className="space-x-4 text-center">
          <Link href="https://brimble.io" className="text-blue-500">
            Home
          </Link>
          <Link
            href="https://www.youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500"
          >
            YouTube
          </Link>
          <Link
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500"
          >
            Twitter
          </Link>
        </div>
      </div>
    </>
  );
};

export default DesktopOnlyNotice;
